import React from 'react';
import PropTypes from 'prop-types';
import { Logo } from 'components/atoms';
import { Button, Heading, Box, Text } from 'grommet';

const SearchButtonUI = ({
  onClick,
  disabled,
  title,
  showLogo,
  ...otherButtonProps
}) => {
  return (
    <Box flex={'shrink'}>
      <Button
        primary
        style={{
          'border-radius': '50rem',
          'padding-left': '3rem',
          'text-transform': 'uppercase',
        }}
        data-testid={'search-button'}
        color={'buttonBackgroundColor'}
        disabled={disabled}
        onClick={onClick}
        reverse
        label={
          title ? (
            <Text
              data-testid={'button-label'}
              margin={'small'}
              color={'buttonTextColor'}
              size={'small'}
              style={{
                'font-family': '"Georgia", serif',
              }}
            >
              {title}
            </Text>
          ) : undefined
        }
        icon={
          showLogo ?
            <img src="/images/icons/logos/transparent/white-hand-transparent.png"
                 width={60} />
          : null
        }
        {...otherButtonProps}
      />
    </Box>
  );
};

SearchButtonUI.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
};

SearchButtonUI.defaultProps = {
  onClick: () => {},
  disabled: false,
  title: '',
  color: 'cta',
  showLogo: true,
};

export default SearchButtonUI;
